import DetailLearnTracks from '@/views/LearnDashboard/components/Revamp/views/DetailLearnTracks';

const RevampDetailTrack = () => {
  return <DetailLearnTracks />;
};

export default RevampDetailTrack;
